<template>
    <v-row>
        <v-col md="6">
            <v-btn color="red" @click="downloadAll">
                <v-icon>mdi-download-multiple</v-icon>
            </v-btn>
        </v-col>
        <v-col md="6">
            <v-btn @click="downloadAllSlow">
                <v-icon>mdi-download-outline</v-icon>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
    import $ from "jquery";
    export default {
        data: () => ({

        }),
        methods: {
            downloadAll() {
                let images = document.querySelectorAll("a[download]");
                if(images){
                    for(let i=0; i < images.length; i++)
                    {
                        var image = images[i];
                        image.click();
                    }
                }
            },
            downloadAllSlow(){
                var i = 0;
                var myInter  = setInterval(function(){
                    if(i==$("a[download]").length){
                        clearInterval(myInter);
                    }
                    $("a[download]")[i].click();
                    i++;
                },500);
            }
        }
    }
</script>

<style scoped>

</style>